var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.25C3.75 14.8063 7.44365 18.5 12 18.5C16.5563 18.5 20.25 14.8063 20.25 10.25C20.25 5.69365 16.5563 2 12 2C7.44365 2 3.75 5.69365 3.75 10.25ZM11.4453 6.16602C11.8595 6.16602 12.1953 6.5018 12.1953 6.91602V10.1166L14.1089 11.2215C14.4676 11.4286 14.5905 11.8873 14.3834 12.246C14.1763 12.6047 13.7176 12.7276 13.3589 12.5205L11.0703 11.1992C10.8383 11.0652 10.6953 10.8176 10.6953 10.5496V6.91602C10.6953 6.5018 11.0311 6.16602 11.4453 6.16602Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.25 14.4375V19.7498C20.25 20.9925 19.2426 21.9998 18 21.9998H6C4.75736 21.9998 3.75 20.9925 3.75 19.7498V14.4375C5.27796 17.4417 8.39863 19.4998 12 19.4998C15.6014 19.4998 18.722 17.4417 20.25 14.4375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoClock);
export default __webpack_public_path__ + "static/media/DuoClock.2f576df3707dfa718479a20747a147aa.svg";
export { ForwardRef as ReactComponent };